<template>
  <div>
    <b-card v-if="moduleAccess == 1">
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Appearance'}">
              <h4 class="m-dir-2">
                {{label.pages.Appearance}}
              </h4>
            </b-link>
            /
            <h4 class="m-dirR-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.manageSlider}}
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-tabs
              nav-class="tab-title"
              active-nav-item-class="tab-title-active"
              fill
              justified
              pills
          >
            <!-- main Slider -->
            <b-tab active>
              <template #title>
                {{label.pages.slider}}
              </template>
              <sliders-tab />
            </b-tab>
            <!-- Banners -->
            <b-tab>
              <template #title>
                {{label.pages.banner}}
              </template>
              <banners-tab />
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-card>

    <b-card v-else>
        <ModuleAccess />
    </b-card>
  </div>
</template>

<script>
import BannersTab from '@/views/pages/appearance/Banners'
import SlidersTab from '@/views/pages/appearance/Sliders'
import label from "@/plugins/StaticLabels.js";
import ModuleAccess from "@/components/ModuleAccess";

export default {
  name: 'BannersAndSlider',
  data(){
    return{
      label,
      moduleAccess: process.env.VUE_APP_BANNER_SLIDER,
    }
  },
  components: {
    BannersTab,
    SlidersTab,
    ModuleAccess,
  },
}
</script>
